// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ellipsis[data-v-531080d5]{text-overflow:ellipsis}.contacts-list[data-v-531080d5]{overflow:visible !important}\n", ""]);
// Exports
module.exports = exports;
